import type { AnalyticsProvider } from "../types"

// Used when analytics is disabled and we're not in dev — does nothing.
export const noopProvider: AnalyticsProvider = {
  capture() {},
  identify() {},
  alias() {},
  captureException() {},
}
